document.addEventListener('DOMContentLoaded', function() {
    const oldH1Title = document.querySelector('.collection-hero__description h1');
    const oldH2Title = document.querySelector('.shopify-section.section[id*="8Nqj7A"] h2');

    if(oldH1Title && oldH2Title) {
        const newH1 = document.createElement('h1');
        newH1.innerHTML = oldH1Title.innerHTML;
        oldH2Title.replaceWith(newH1);

        const newH2Title = document.createElement('h2');
        newH2Title.style.marginBottom = '2rem';
        newH2Title.innerHTML = `${oldH1Title.innerHTML} Overview`;
        oldH1Title.replaceWith(newH2Title);
        return;
    }
    
    if(oldH2Title && !oldH1Title) {
        const newH1 = document.createElement('h1');
        newH1.innerHTML = oldH2Title.innerHTML;
        oldH2Title.replaceWith(newH1);
        oldH2Title.remove();
        return;
    }
});